import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlideAdd"><Path d="M16.5 7.5V2.5H2.5V16.5H7.5M14.5 11.5V14.5M14.5 14.5V17.5M14.5 14.5H11.5M14.5 14.5H17.3919M7.5 7.5H21.5V21.5H7.5V7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlideAdd;
